"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConsentText = exports.ConsentLayer = exports.ConsentButtonAlternative = exports.ConsentButton = exports.ConsentActions = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _breakpoints = require("@titelmedia/bricks-theme/lib/variables/breakpoints");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ConsentLayer = _styledComponents.default.div`
  box-sizing: border-box;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0,0,0,0.8);
  color: white;
  padding: 32px;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 40px;
  font-family: Helvetica, Arial, sans-serif;
  line-height: 1.4;
  z-index: 999999;
  backdrop-filter: blur(5px);
  display: ${({
  isVisible
}) => isVisible ? 'flex' : 'none'};

  @media only screen and (max-width: ${_breakpoints.BREAKPOINTS.sm}px) {
    flex-direction: column;
  }
`;
exports.ConsentLayer = ConsentLayer;
const ConsentText = _styledComponents.default.div`
  max-width: 80ch;
  font-size: 13px;
  text-align: left;
`;
exports.ConsentText = ConsentText;
const ConsentActions = _styledComponents.default.div`
  max-width: 250px;
  flex: 1;

  @media only screen and (max-width: ${_breakpoints.BREAKPOINTS.sm}px) {
    max-width: none;
    width: 100%;
  }
`;
exports.ConsentActions = ConsentActions;
const ConsentButton = _styledComponents.default.button`
  width: 100%;
  display: block;
  margin-bottom: 10px;
  height: 45px;
  border-radius: 3px;
  background: white;
  color: black;
  border: 0;
  text-transform: uppercase;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
  &:last-child {
    margin-bottom: 0;
  }
`;
exports.ConsentButton = ConsentButton;
const ConsentButtonAlternative = (0, _styledComponents.default)(ConsentButton)`
  border: 1px solid white;
  background: transparent;
  color: white;
`;
exports.ConsentButtonAlternative = ConsentButtonAlternative;
//# sourceMappingURL=styles.js.map